import { ArrowRight } from "lucide-react";
import { FadeUp, MaskLine } from "@/components/Reveal";

const LINKEDIN = "https://www.linkedin.com/in/naomilennon";
const EMAIL = "naomi@lennonmgmt.com";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-accent text-white">
      <div className="mx-auto max-w-[1500px] px-6 py-24 md:px-10 md:py-36 lg:px-14">
        <h2>
          <MaskLine innerClassName="font-display text-[9vw] font-extrabold uppercase leading-[0.94] tracking-[-0.02em] [font-stretch:118%] sm:text-6xl md:text-[4.6vw]">
            You have the growth target.
          </MaskLine>
          <MaskLine delay={0.15} innerClassName="font-display text-[9vw] font-extrabold uppercase leading-[0.94] tracking-[-0.02em] text-ink [font-stretch:118%] sm:text-6xl md:text-[4.6vw]">
            The creator capability is already in place.
          </MaskLine>
        </h2>

        <div className="mt-12 flex flex-col gap-10 md:flex-row md:items-end md:justify-end">
          <FadeUp delay={0.3} className="flex flex-wrap items-center gap-6">
            <a
              href={LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-linkedin-button"
              className="group inline-flex items-center gap-3 bg-ink px-8 py-4 text-[13px] font-bold uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:bg-paper hover:text-ink"
            >
              Talk to Lennon
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-button"
              className="border-b-2 border-white/50 pb-1 text-[13px] font-bold uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:border-white"
            >
              {EMAIL}
            </a>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
